// Brand Colors
export const COLORS = {
    primary: '#2666a6',    // Azul Fila0
    success: '#16A34A',    // Verde
    warning: '#F59E0B',    // Amarelo
    background: '#F9FAFB', // Cinza claro
    text: '#1F2933'        // Cinza escuro
};

// Status da busca
export const STATUS = {
    chegando: {
        label: 'Estou chegando',
        color: COLORS.warning,
        icon: '🚗',
        bgClass: 'bg-orange-100',
        textClass: 'text-orange-800',
        borderClass: 'border-orange-300'
    },
    preparando: {
        label: 'Preparando',
        color: COLORS.primary,
        icon: '📝',
        bgClass: 'bg-blue-100',
        textClass: 'text-blue-800',
        borderClass: 'border-blue-300'
    },
    pronto: {
        label: 'Pronto',
        color: COLORS.success,
        icon: '✅',
        bgClass: 'bg-green-100',
        textClass: 'text-green-800',
        borderClass: 'border-green-300'
    },
    entregue: {
        label: 'Fila 0! 🎉',
        color: COLORS.success,
        icon: '🎉',
        bgClass: 'bg-green-100',
        textClass: 'text-green-800',
        borderClass: 'border-green-300'
    },
    cancelado: {
        label: 'Cancelado',
        color: '#6B7280',
        icon: '❌',
        bgClass: 'bg-gray-100',
        textClass: 'text-gray-800',
        borderClass: 'border-gray-300'
    }
};

// Rotas da aplicação
export const ROUTES = {
    HOME: '/',
    DEMO: '/demo',
    APP_PARENT: '/app/pai',
    APP_SCHOOL: '/app/escola',
    LOGIN: '/',
    LOGIN_LEGACY: '/login',
    REGISTER: '/cadastro'
};
